import { getCookie } from "../cookies";
import { MAINTENANCE_OVERRIDE_COOKIE } from "./constants";

let maintenanceModeFlagValue: unknown;
let maintenanceModeUnavailable = false;

export const setMaintenanceModeFlagValue = (value: unknown) => {
  maintenanceModeFlagValue = value;
};

export const setMaintenanceModeUnavailable = (value: boolean) => {
  maintenanceModeUnavailable = value;
};

export const hasMaintenanceOverride = () =>
  getCookie(MAINTENANCE_OVERRIDE_COOKIE) === "true";

export const isMaintenanceModeFlagActive = (value: unknown) =>
  value === true || value === "true";

export const isMaintenanceModeActive = () => {
  if (hasMaintenanceOverride()) {
    return false;
  }

  return (
    isMaintenanceModeFlagActive(maintenanceModeFlagValue) ||
    maintenanceModeUnavailable
  );
};
